// A list of actions to be shown in a SelectionActionView and acted on by a SelectionModel

import Backbone from "backbone";
import * as _ from "underscore";

import * as utils from "shared/utils";

const SelectionAction = Backbone.Model.extend({
  perform: function (selectionModel) {
    if (this.exec) {
      this.exec();
    } else {
      selectionModel.performAction(this.id);
    }
  },
  appliesToSelection: function (selectionModel, options) {
    // all selected items have to match all conditions to show
    if (
      !options.itemIDsOnly &&
      (selectionModel.get("wholeCollection") || selectionModel.get("wholePage"))
    ) {
      return this.checkForMatch(
        this.get("applyQuery"),
        selectionModel.collection.searchQuery.toJSON()
      );
    } else {
      // fetch all itemIDs - see if ANY of them match
      return _.any(selectionModel.get("itemIDs"), (itemID) => {
        const model = selectionModel.collection.get(itemID);

        // check that every condition matches
        return this.checkForMatch(this.get("applyQuery"), model.toJSON());
      });
    }
  },
  appliesToItem: function (model) {
    return this.checkForMatch(this.get("applyQuery"), model.toJSON());
  },
  checkForMatch: function (query, json) {
    const result = _.every(query, (value, key) => {
      if (key === "$and") {
        return _.every(value, (condition) =>
          this.checkForMatch(condition, json)
        );
      } else if (key === "$or") {
        return _.any(value, (condition) => this.checkForMatch(condition, json));
      } else if (typeof value === "object") {
        return _.every(value, (conditionValue, conditionType) => {
          switch (conditionType) {
            case "$exists":
              return utils.childExists(json, key) === conditionValue;
            case "$ne":
              return !this.checkEqualOrContains(
                utils.valueFromPath(json, key),
                conditionValue
              );
            case "$not": {
              const subQuery = {};
              subQuery[key] = conditionValue;
              return !this.checkForMatch(subQuery, json);
            }
            case "$size": {
              const innerValue = utils.valueFromPath(json, key);
              return innerValue && innerValue.length === conditionValue;
            }
            default:
              throw new Error("condition type not supported: " + conditionType);
          }
        });
      } else {
        return this.checkEqualOrContains(utils.valueFromPath(json, key), value);
      }
    });
    return result;
  },
  checkEqualOrContains: function (documentValue, value) {
    if (!documentValue) {
      return false;
    }
    if (documentValue instanceof Array) {
      return _.contains(documentValue, value);
    }
    return documentValue === value;
  },
});

const SelectionActionList = Backbone.Collection.extend({
  model: SelectionAction,
  initialize: function (options) {
    this.selectionModel = options.selectionModel;
  },
});

export default SelectionActionList;
